import { File } from '../file';
/**
 * Model definition for NumberCounter
 */
export interface ContentNumberCounter {
  __component: 'content.number-counter';
  id: string;
  startValue: number;
  endValue: number;
  unit: string;
  duration: number;
  text: string;
  media?: File;
  headlineTitle?: string;
}

export function isContentNumberCounter(obj: { __component?: string }): obj is ContentNumberCounter {
  return obj.__component === 'content.number-counter';
}
